import { materialConfig } from '@/common/config';
import axios,{ AxiosRequestConfig, AxiosError }  from 'axios';
import { isNeedLogin } from './access';
import { lang } from '@/locales';
const instance: any = axios.create({
  baseURL: materialConfig,
  timeout: 40000,
  headers: {
    'Content-Type': 'application/json',
    // 'Accept-Language': lang
  }
});
instance.defaults.withCredentials = true;
instance.interceptors.response.use();
// 添加请求拦截器
instance.interceptors.request.use(
 async (config:AxiosRequestConfig) => {
    // const lang = await svgLang.getLocale();
    // 在请求发送之前做一些处理
    config.headers = {};
    config.headers['Accept-Language'] = lang; // 设置请求头

    return config;
  },
  (error:AxiosError) => {
    // 抛出请求错误
    return Promise.reject(error);
  }
);
// 响应拦截器
instance.interceptors.response.use(
  async (response: { status: number; data: any; request: any }) => {
    const res = await isNeedLogin(response.request.responseURL, response.data.code)
    if (res) {
      return Promise.reject(response.data.msg);
    }
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
    // 否则的话抛出错误
    if (response.status === 200) {
      return Promise.resolve(response.data);
    } else {
      return Promise.reject(response);
    }
  },
  (
    error: { response: { status: any; data: { message: any; }; }; }) => {
    // console.log(error)
    if (error?.response?.status) {
      return Promise.reject(error?.response);
    }
  }
)
export default instance;
